<template>
  <div id="main-app">
    <div v-if="basePageLoaded">
      <div v-if="user && showImpersonateBanner" class="white red-bg py1 center sticky top-0 z4">
        Vous êtes connecté pour le compte de: {{ user.firstname }} {{ user.lastname }} sur le site {{ site.name }}
        <a class="ml2 dark-grey-bg white p1 pointer" @click="handleLogout">
          <i class="icon icon-logout mr1"></i>
          <span>Déconnexion</span>
        </a>
      </div>
      <header>
        <div class="col-12 px2 flex justify-between top-menu full-height">
          <div class="sm-col-6 md-col-2 lg-col-2 col-6 left ml2 flex items-center full-height">
            <span class="flex items-center pointer full-height" @click="goToHome()"> <!--fix-->
              <img v-if="logo_type && logo_type === 'IMAGE'" class="logo-ucpa" :src="logo">
              <div v-else>
                <h2 v-if="!!text_logo_type" class="caps h6n m0">{{ text_logo_type }}</h2>
                <h3 v-if="!!text_logo_name" class="caps h6n regular m0">{{ text_logo_name }}</h3>
              </div>
            </span>
          </div>
          <div class="sm-col-6 md-col-10 lg-col-10 col-6 flex items-center justify-end pointer">
            <!-- <span class="h6n bold items-center px1 white">Jean Dupont</span> -->
            <span class="pointer" style="height:30px" @click="goToHome()">
              <i class="icon-cancel" style="font-size: 30px;"></i>
            </span>
          </div>
        </div>
      </header>
      <div class="page-body">
        <Breadcrumb />

        <div class="flex flex-wrap full-height content-stretch">
          <div id="menu-block">
            <Menu id="menu-desktop" class="xs-hide sm-hide mt3" />
          </div>
          <div id="content-block" class="grey-bg relative">
            <div id="scrollable-content" class="full-height scrollable" :style="scrollableHeight">
              <div class="full-height grey-bg">
                <router-view />
              </div>
            </div>
            <Menu id="menu-mobile" class="md-hide lg-hide white-bg" style="height:75px" />
          </div>
        </div>
      </div>
    </div>
    <LoadingOverlay />
    <notifications position="bottom left" />
  </div>
</template>
<script>

import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Menu from '@/components/menu/Menu';

import Breadcrumb from '@/components/common/Breadcrumb';
import LoadingOverlay from '@/components/common/LoadingOverlay';

import { getSiteInfo, getUser, getDisplayContent, isImpersonateMode, getAllowedProductsDetails } from '@/mixins/requests';
import { assetsPath } from '@/mixins/utils';

export default {
  components: {
    Menu,
    Breadcrumb,
    LoadingOverlay
  },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const showImpersonateBanner = computed(() => store.getters.isImpersonateMode);

    // const returnUrl = cookies.get('return_url');
    // TODO Disable until proper cookie implementation client
    // console.log('teste',VueCookies)
    // const returnUrl = computed(() => {
    //   let link = '/';
    //   const cookieLink = this && this.$cookies.get('return_url');
    //   if (cookieLink && !returnUrl.value.includes('/espacepersonnel')) {
    //     link = cookieLink;
    //   }

    //   return link;
    // });
    const returnUrl = ref('/');
    const site = computed(() => store.state.siteInfo);
    const user = computed(() => store.state.user);
    const logoutLink = computed(() => `/${route.params.site_preroute}/af/logout?return=${window.location.protocol}//${window.location.hostname}/${route.params.site_preroute}${route.params.site_url ? `/${route.params.site_url}` : ''}`);

    const basePageLoaded = ref(false);
    const windowWidth = ref(window.innerWidth);
    const windowHeight = ref(window.innerHeight);

    const logo = ref(null);
    const text_logo_type = ref(null);
    const text_logo_name = ref(null);
    const logo_type = ref(null);

    const scrollableHeight = computed(() => {
      const computedHeight = [`${windowHeight.value}px`];

      // Top Header
      computedHeight.push('50px');

      // Bottom menu only available in mobile
      if (windowWidth.value < 832) {
        computedHeight.push('76px');
      }

      // Base breadcrumb only available in some contexts
      if (route.meta.breadcrumb) {
        computedHeight.push('70px');
      }

      return `height: calc(${computedHeight.join(' - ')})`;
    });

    // const generateManifest = async () => {
    //   const manifest = await fetch('/sport-station/espacepersonnel/manifest.json')
    //     .then(res => res.json());
    //   if (manifest) {
    //     let name = text_logo_type.value;
    //     name = name ? `${name} ${text_logo_name.value}` : text_logo_name.value;

    //     // const newManifest = {
    //     //   ...manifest,
    //     //   id: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/${store.state.siteInfo.siteUrl}`,
    //     //   name: name && name !== '' ? name.toUpperCase() : manifest.name,
    //     //   short_name: store.state.siteInfo.name,
    //     //   start_url: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/${store.state.siteInfo.siteUrl}`,
    //     //   icons: (manifest.icons || []).map(i => ({ ...i, src: `${window.location.origin}/sport-station/espacepersonnel/${i.src}` }))
    //     // };
    //     const newManifest = {
    //       ...manifest,
    //       id: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/${store.state.siteInfo.siteUrl}`,
    //       name: name && name !== '' ? name.toUpperCase() : manifest.name,
    //       short_name: store.state.siteInfo.name,
    //       start_url: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/${store.state.siteInfo.siteUrl}`,
    //       icons: [
    //         {
    //           src: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/img/icons/WebApp-Icon-USS-violet-144px.png`,
    //           sizes: '144x144'
    //         },
    //         {
    //           src: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/img/icons/WebApp-Icon-USS-violet-144px.png`,
    //           sizes: '144x144',
    //           purpose: 'maskable'
    //         },
    //         {
    //           src: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/img/icons/WebApp-Icon-USS-violet-192px.png`,
    //           sizes: '192x192'
    //         },
    //         {
    //           src: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/img/icons/WebApp-Icon-USS-violet-192px.png`,
    //           sizes: '192x192',
    //           purpose: 'maskable'
    //         },
    //         {
    //           src: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/img/icons/WebApp-Icon-USS-violet-512px.png`,
    //           sizes: '512x512'
    //         },
    //         {
    //           src: `${window.location.origin}/${store.state.siteInfo.site_preroute}/espacepersonnel/img/icons/WebApp-Icon-USS-violet-512px.png`,
    //           sizes: '512x512',
    //           purpose: 'maskable'
    //         }
    //       ]
    //     };
    //     const stringManifest = JSON.stringify(newManifest);
    //     console.log(newManifest);
    //     const blob = new Blob([stringManifest], { type: 'application/json' });
    //     const manifestURL = URL.createObjectURL(blob);

    //     document.querySelector('[rel=manifest]').setAttribute('href', manifestURL);
    //   }
    // };

    const goToHome = () => {
      let url = `/${route.params.site_preroute}${route.params.site_url ? `/${route.params.site_url}` : ''}`;
      if (store.getters.isImpersonateMode) {
        url += `?impersonateData=${store.state.impersonateData}`;
      }
      store.commit('setImpersonateData', null);
      window.location.href = url;
    };

    const routeParams = computed(() => route.params);
    const routeQuery = computed(() => route.query);

    onMounted(async () => {
      store.commit('setLoading', true);
      const { impersonateData } = route.query;
      let impersonateResponse = null;
      if (impersonateData) {
        store.commit('setImpersonateData', impersonateData);
        impersonateResponse = await isImpersonateMode({ site_preroute: routeParams.value.site_preroute, site_url: routeParams.value.site_url });
      }

      const userAux = await getUser({ site_preroute: routeParams.value.site_preroute, site_url: routeParams.value.site_url });
      if (!userAux) {
        return null; // Loading and redirect to SSO
      }

      if (routeParams.value.site_preroute !== undefined) {
        const siteInfo = await getSiteInfo({ site_preroute: routeParams.value.site_preroute, site_url: routeParams.value.site_url }, impersonateData);

        if (!siteInfo) {
          router.push({ name: 'Home', params: { site_preroute: 'sport-station', site_url: 'grand-reims' }, query: routeQuery.value });
          store.commit('setReload', store.state.reload + 1);
          return true;
        }
        store.commit('setSiteInfo', siteInfo.data);

        if (impersonateResponse && (!impersonateResponse.success || !impersonateResponse.data || impersonateResponse.data.workspace !== store.state.siteInfo.workspace)) {
          store.commit('setImpersonateData', null);
          goToHome();
          return;
        }

        if (siteInfo && siteInfo.data) {
          document.title = `${siteInfo.data.name} : Espace Personnel`;
          const { perso_settings, site_settings } = siteInfo.data;
          text_logo_name.value = siteInfo.data.name;

          if (site_settings) {
            logo_type.value = site_settings.logo_type;
            logo.value = site_settings.logo;
            text_logo_type.value = site_settings.text_logo_type;
            text_logo_name.value = site_settings.text_logo_name || text_logo_name.value;
          }

          if (logo_type.value && logo_type.value === 'IMAGE') {
            if (perso_settings && perso_settings.logo) {
              logo.value = perso_settings.logo;
            }
          } else if (!text_logo_type.value) {
            switch (route.params.site_preroute) {
              case 'sport-station':
                text_logo_type.value = 'ucpa sport station';
                break;
              case 'aqua-stadium':
                text_logo_type.value = 'ucpa aqua stadium';
                break;
              case 'centres-sportifs':
                text_logo_type.value = 'ucpa sport access';
                break;
              default:
                text_logo_type.value = 'ucpa';
                break;
            }
          }
        }

        router.replace({ query: { } });
        // await generateManifest();
        await getDisplayContent();

        // get allowed product informations
        await getAllowedProductsDetails(userAux.data);
        basePageLoaded.value = true;
        store.commit('setLoading', !basePageLoaded.value);
      }

      store.commit('setLoading', false);
      window.onresize = () => {
        windowWidth.value = window.innerWidth;
        windowHeight.value = window.innerHeight;
      };
      return true;
    });

    const handleLogout = () => {
      store.commit('setImpersonateData', null);
      window.location.href = logoutLink.value;
    };

    return {
      handleLogout,
      logo,
      text_logo_type,
      text_logo_name,
      logo_type,
      basePageLoaded,
      returnUrl,
      windowWidth,
      scrollableHeight,
      goToHome,
      assetsPath,
      route,
      store,
      site,
      user,
      logoutLink,
      showImpersonateBanner
    };
  }
};
</script>
<style>
/* Imports of static css files */
@import '@/assets/css/common.css';
html {
  overflow: hidden;
}

header {
  border-bottom: 1px solid #e4e9ee;
  height: 50px;
}

.icon-cancel:hover{
  color:#e81d00;
}

.logo-ucpa {
  height: 80%;
  /* filter: invert(1); */
}

.top-menu {
  /* source: https://cssgradient.io/ */
  /*
  background: rgb(132,164,201);
  background: linear-gradient(90deg, rgba(132,164,201,1) 0%, rgba(179,199,223,1) 43%, rgba(110,140,176,1) 100%);
  */

  background-color: white
}

#menu-block {
  width: 0%;
}

#menu-mobile {
  border-top: 1px solid #e4e9ee;
}

.page-body {
  height: calc(100vh - 50px);
}

#content-block {
  width: 100%;
}

@media screen and (min-width: 52rem) {
  #menu-block {
    width: 20%;
    border-right: 1px solid #e4e9ee;
  }

  #content-block {
    border-bottom: 0px;
    width: 80%;
  }

}
</style>
